<form [formGroup]="assessmentBasicForm" class="mx-auto w-full max-w-[480px] gap-4">
  <div class="custom-mat-form-wrapper">
    <div class="mat-form-label">{{ 'assessment.assessment_form.name' | transloco }}</div>
    <mat-form-field appearance="fill" class="size-l w-full">
      <input
        required
        matInput
        [formControl]="assessmentBasicForm.controls.name"
        placeholder="{{ 'assessment.assessment_form.name_example' | transloco }}"
      />
      @if (assessmentBasicForm.controls.name.hasError('maxlength')) {
        <mat-error> {{ 'assessment.assessment_form.name_error' | transloco }} </mat-error>
      }
    </mat-form-field>
  </div>

  <div class="custom-mat-form-wrapper date-picker-wrapper pt-8">
    <div class="mat-form-label">{{ 'assessment.assessment_form.date' | transloco }}</div>
    <mat-form-field class="date-form-field size-l w-full" appearance="fill" [dojoDatepickerToggle]="picker">
      <input
        required
        matInput
        [formControl]="assessmentBasicForm.controls.date"
        placeholder="DD/MM/YYYY"
        [matDatepicker]="picker"
        [errorStateMatcher]="DirtyInvalidErrorStateMatcher"
      />
      <mat-datepicker-toggle matSuffix [dojoDatepickerToggle]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>

  @if (!assessmentBasicForm.controls.isActive.disabled) {
    <div class="custom-mat-form-wrapper grid gap-2 pt-8">
      <div class="flex w-full items-center justify-between gap-2">
        <div class="mat-form-label" style="margin-bottom: 0px !important">
          {{ 'assessment.assessment_form.is_active' | transloco }}
        </div>
        <mat-slide-toggle class="size-m" [formControl]="assessmentBasicForm.controls.isActive" color="primary" />
      </div>
      <div class="text-secondary w-full">{{ 'assessment.assessment_form.is_active_description' | transloco }}</div>
    </div>
  }
</form>
